import type {
  APIViewpointAttributes,
  WithTransactionId,
} from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';

export type ApplyFormattingAndLabelRulesParams = WithTransactionId & {
  rules: APIViewpointAttributes['conditionalFormatting'];
};

export const formattingAndLabelRulesRequested =
  actionCreator<ApplyFormattingAndLabelRulesParams>(
    '[traversals] FORMATTING_AND_LABEL_RULES_REQUESTED'
  );
